<template>
    <div>
            <q-modal v-model="dialogVisible" no-backdrop-dismiss  @escape-key="unlockExecutor">    
                <q-toolbar color="primary" style="justify-content:space-between;" class='contragent-dialog'>
                    <q-toolbar-title shrink>
                        Редактирование исполнителя
                    </q-toolbar-title>
                </q-toolbar>       
                <form action="#" @submit.prevent="okDialog">  
                    <div class="dialog-container">
                        <div class="q-ma-xs q-pa-xs">
                            <q-input v-model="data.name" float-label="Наименование исполнителя*"/>
                        </div>
                        <div class="q-ma-xs">
                            <q-input v-model="contact" float-label="Контактное лицо*"/>
                        </div>

                        <div class="row no-wrap q-ma-xs">
                            <div class="col">
                                <q-input v-model="phone" float-label="Контактный телефон*"/>
                            </div>
                            <div class="col q-ml-lg">
                                <q-input v-model="email" float-label="e-mail*" type='email'/>
                            </div>
                        </div>

                        <div class="row no-wrap q-ma-xs ellipsis">
                            <div class="q-ma-xs col">
                                <q-input v-model="adress" float-label="Адрес"/>
                            </div>

                            <div class="q-ma-xs col">
                                <q-input v-model="comment" float-label="Комментарии"/>
                            </div>
                        </div>
                        <div class='round-borders q-pa-md q-mt-md' style="border: 1px dotted gray;">
                            <q-select
                                multiple
                                color="primary"
                                v-model="direction"
                                chips
                                :options="directionsList"
                                float-label="Направления*"  
                                @input = 'q'
                                :after="[
                                    {
                                        icon: 'close',
                                        content: true,
                                        handler () {
                                            emptyDirections();
                                        }
                                    }
                                ]"
                            />
                        </div>

                      

                    </div>
                    <div class="button-container row no-wrap q-ma-sm justify-end ">
                        <q-btn label="отмена" icon="cancel" color="negative" outline  class="q-ma-sm" @click="cancelDialog" />
                        <q-btn label="сохранить" icon="save" color="positive" class="q-ma-sm" type="submit" :loading='loading' style="width:150px;"/>
                    </div>
                </form>
            </q-modal>
        
    </div>    
</template>

<script>
/* eslint-disable */
export default {
    name : 'executerEditDialog',

    data() {
        return {

            dialogVisible : false,
            data : {},
            emptyData : {
                id : -1,
                name : '',
                directions : '[]',
                options : JSON.stringify({'email':'', 'phone':'', 'contact':'','adress':''}),
                active : 1,
            },
            loading : false,
        }
    },

    created() {
        eventBus.$on('openExecuterEditDialog', this.openDialog);
        this.setEmptyData(); // присваиваем начальные значения диалоговому окну
    },

    beforeDestroy() {
        eventBus.$off('openContragentEditDialog');
    },

    computed : {
        
        direction : {
            get : function() {
                return JSON.parse(this.data.directions);                
            },
            set : function(newValue) {
                this.data.directions = JSON.stringify(newValue);
            }
        },

        directionsList() {
            var list = [];
            if (this.$store.getters.getAllDirections==undefined) return list;
            this.$store.getters.getAllDirections.map((value,key)=>{
                list.push({label:value.name, value:value.id});
            });
          return list;        
        },

        contact : {
            get : function(){
                return this.getParam('contact');
            },
            
            set : function(newValue) {
                this.setParam('contact', newValue);
            }
        },

        adress : {
            get : function(){
                return this.getParam('adress');
            },
            
            set : function(newValue) {
                this.setParam('adress', newValue);
            }
        },

        comment : {
            get : function(){
                return this.getParam('comment');
            },
            
            set : function(newValue) {
                this.setParam('comment', newValue);
            }
        },



        email: {
            get:function() {
                return this.getParam('email');
            },

           set:function(newValue) {
                this.setParam('email', newValue);
            }
        },

        phone: {
            get : function() {
                return this.getParam('phone');
            },
            set : function(newValue) {
              this.setParam('phone', newValue);
            }
        },

    },

    methods : {
        q() {
            console.log(this.data.directions);
        },

        emptyDirections() {
            this.data.directions = '[]';
        },

        getParam(name) {
            if (this.data.options == undefined) return '';
            let opt = JSON.parse(this.data.options);
            if (opt[name] == undefined) return '';
            return opt[name];
        },

        setParam(name, value) {
            let opt = JSON.parse(this.data.options);
            opt[name] = value;
            this.data.options = JSON.stringify(opt);
        },

        unlockExecutor(){
            if (this.data.id>-1) {
                this.$store.dispatch('unlockExecutor', this.data.id)
                .then(()=>{

                })
                .catch(error=>{
                    this.$admns.showNotify('Не удалось разблокировать запись','error','Сообщение системы');
                    console.log(error);
                });
            }
        },

        setEmptyData() {
            this.data = Object.assign({}, this.emptyData);
        },

        openDialog(id){

            if (id>-1) { // если редактируем уже существующего контрагента - загружаем данные в него
                var q = this.$store.getters.getExecuterById(id);
                if (q != undefined) this.data = Object.assign({}, q);
                if (this.data.options == null) this.data.options = this.emptyData.options;
            } else this.setEmptyData(); // иначе обнуляем все поля ввода

            this.dialogVisible = true;

        },

        cancelDialog() {
            this.dialogVisible = false;
            this.unlockExecutor();
        },

        okDialog() {
            if (this.data.name=='') {
                this.$admns.showNotify('Необходимо ввести наименование исполнителя','error','Сообщение системы');
                return;
            }
            this.loading = true;
            this.$store.dispatch('saveExecuter', this.data)
            .then(()=>{
                this.loading = false;
                this.dialogVisible = false;
                this.$admns.showNotify('Исполнитель сохранен','success','Сообщение системы');
                // if (this.data.id>-1) { // мы редактировали - поэтому стоит разблокировать запись.
                    // this.unlockContragent();
                // }
            })
            .catch((error)=>{
                this.loading = false;
                console.log(error);
                this.$admns.showNotify('Ошибка сохранения контрагента','error','Сообщение системы');
            });
            
        }


    }


}
</script>

<style lang="scss" scoped>
    .contragent-dialog {
        min-width:600px;
        width : 100%;
    }
    .dialog-container {
        min-height: 350px;
        padding: 20px;
    }
</style>



